import {Component, Input, OnInit} from "@angular/core";
// import {BaseCmsContentModel} from "../../models/base-cms-content.model";
import {CmsLinkModel} from "../../models/cms-link.model";
import {RecommendedLinkModel} from "../../models/recommended-link.model";

@Component({
    selector: "pcg-ng-recommended-links",
    template: require('./recommended-links.component.html'),
    styles: [
    ]
})
export class RecommendedLinksComponent implements OnInit {
    @Input() public recommendedLinks: Array<RecommendedLinkModel>;
    @Input() public addServiceLink: CmsLinkModel;

    public constructor() { }

    public ngOnInit(): void {
        this.recommendedLinks.forEach(item => {
           if (!(item.url.startsWith("/") || new URL(item.url).origin === location.origin)) {
               item.isExternal = true;
           }
        });
    }
}
